<template>
    <div class="news-list-item lef-img-item tapable_el" @click.stop="openContent()"  v-if="data " tapmode  >

        <div class="news-list-item-scrolltext-box">
            <div class="news-list-item-scrolltext-img">
                <img :src="data.thumb[0]?data.thumb[0]+'?x-oss-process=image/resize,m_lfit,h_200,w_200':currentpath+'image/logo.png'" @error="setdefaultImg($event)">
            </div>
            <div class="news-list-item-scrolltext-right">
                <div class="text-overflow lef-img-item-title">{{data.title}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import utils from "../utils";
    export default {
        name: "leftImg",
        props: {
            height: Number,
            data: Object,
            is_spec: Boolean,
            nav_url: String,
            title: String,
        },
        methods: {
            setdefaultImg(event) {
                var el = event.currentTarget;
                el.style.opacity = 0
            },
            openContent() {
               if (this.data.art_link) {
                    utils.openPage(this.data,this)
                } else {
                    this.$router.push({name:"NewsContent",params: { id:this.data.art_id}})
                }

            }
        },
    }
</script>

<style scoped>

</style>
